module.exports = __webpack_public_path__ + "img/monitor.53c23e59.png";